<template>
  <section :class="prefixCls" class="flex justify-center items-center">
    <article class="flex items-center">
      <SvgIcon :name="`sys-update`" size="300" />
      <div class="infos ml-8 max-w-95">
        <h1 class="title">{{ t('系统升级中…') }}</h1>
        <span class="desc">尊敬的用户：</span>
        <p class="desc">
          为了提升我们的服务质量和用户体验，我们将进行系统升级。升级期间，我们的系统可能会短暂地停机维护，请您谅解。
        </p>
        <p class="desc"> 升级时间：{{ startTime }} 至 {{ endTime }}（UTC+8）</p>
        <span class="desc">升级期间，您将无法使用我们的服务。</span>
        <p class="desc"> 感谢您一如既往地支持我们，如有任何疑问，请随时联系我们。 谢谢！ </p>
      </div>
    </article>
  </section>
</template>

<script setup lang="ts">
  import { useDesign } from '/@/hooks/web/useDesign';
  import { useI18n } from '@mcex/locale';
  import { SvgIcon } from '/@/components/Icon';
  import { useAppStore } from '/@/store/modules/app';
  import { computed } from 'vue';
  import dayjs from 'dayjs';

  const { prefixCls } = useDesign('main-box');
  const { t } = useI18n();
  const appStore = useAppStore();
  const startTime = computed(() => {
    return dayjs(appStore.getSystemInfo?.startTime).format('YYYY-MM-DD HH:mm');
  });
  const endTime = computed(() => {
    return dayjs(appStore.getSystemInfo?.endTime).format('YYYY-MM-DD HH:mm');
  });
</script>

<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-main-box';

  .@{prefix-cls} {
    height: 100vh;
    width: 100vw;
    background-color: var(--component-bg-color);

    .title {
      color: var(--3-text, rgba(255, 255, 255, 0.36));

      /* 标题/加粗 36px */
      font-family: PingFang SC;
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 44px; /* 122.222% */
    }

    .desc {
      color: var(--2-text, rgba(255, 255, 255, 0.24));

      /* 正文/常规 16px */
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */
    }

    .btn {
      border-radius: var(--radius-radius, 4px);
      background: var(--5-hover, #23bfac);
      padding: 4px 12px;
      color: var(--fill-2, #f7f8fa);

      /* 正文/常规 12px */
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 166.667% */
    }
  }
</style>
